<template>
  <v-sheet :width="'100%'" :elevation="4">
    <v-container>
      <v-row>
        <v-col cols="12" sm="5" md="5" lg="5" v-if="followups.length == 0">
          <FollowUpForm :lead_id="lead_id" :user_id="user_id" />
        </v-col>
        <v-col
          cols="12"
          :sm="followups.length == 0 ? '7' : '12'"
          :md="followups.length == 0 ? '7' : '12'"
          :lg="followups.length == 0 ? '7' : '12'"
        >
          <FollowUpsTable />
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
import FollowUpForm from "@/components/forms/FollowUpForm";
import FollowUpsTable from "@/components/table/agent/FollowUpsTable";
import { mapGetters } from "vuex";

export default {
  name: "Followups",
  props: ["lead_id", "user_id"],
  components: {
    FollowUpForm,
    FollowUpsTable,
  },
  data() {
    return {
      datetime: null,
    };
  },
  computed: {
    ...mapGetters({
      followups: "followups/followups",
    }),
  },
};
</script>

<style>
</style>